import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'vendorSection.title',
    defaultMessage: 'Vendor',
    description: 'title of the vendor section',
  },
  properties: {
    cocNumber: {
      id: 'properties.cocNumber',
      defaultMessage: 'COC number',
      description: 'Label of the property coc number',
    },
    email: {
      id: 'properties.email',
      defaultMessage: 'Email',
      description: 'Label of the property email',
    },
    contact: {
      id: 'properties.contact',
      defaultMessage: 'Contact',
      description: 'Label of the property contact',
    },
    organisation: {
      id: 'properties.organisation',
      defaultMessage: 'Organisation',
      description: 'Label of the property organisation',
    },
    vatCountryCode: {
      id: 'properties.vatCountryCode',
      defaultMessage: 'VAT country code',
      description: 'Label of the property vat country code',
    },
    vatNumber: {
      id: 'properties.vatNumber',
      defaultMessage: 'VAT number',
      description: 'Label of the property vat number',
    },
  },
};

export default defineMessages(translations);
